import z from "zod/v4";
import { branchSchema } from "@libs/aigon-schema/Branch.js";
import { employeeRoleSchema } from "@libs/aigon-schema/EmployeeRole.js";
import { diagnostics } from "../utils/diagnostics";
import { localStorageState } from "../utils/svelte/localStorageState.svelte";

const customerDataSchema = z.object({
	id: z.number(),
	firstName: z.string(),
	lastName: z.string(),
	email: z.string(),
	phone: z.string(),
	contactAddress: z.number(),
	billingAddress: z.number(),
});

const employeeDataSchema = z.object({
	id: z.number(),
	firstName: z.string(),
	lastName: z.string(),
	email: z.string(),
	phone: z.string().nullable(),
	branch: branchSchema.nullable(),
	role: employeeRoleSchema,
	checkKey: z.string(),
});

const baseFields = {
	id: z.string(),
	email: z.string(),
	name: z.string(),
	photo: z.string().optional(),
};

export const loggedInUserSchema = z.discriminatedUnion("role", [
	z.object({ ...baseFields, role: z.literal("customer"), customer: customerDataSchema }),
	z.object({ ...baseFields, role: z.literal("manager"), employee: employeeDataSchema }),
	z.object({ ...baseFields, role: z.literal("instructor"), employee: employeeDataSchema }),
	z.object({ ...baseFields, role: z.literal("admin"), employee: employeeDataSchema.optional() }),
]);

export type LoggedInUser = z.infer<typeof loggedInUserSchema>;

// Increment this when you want to force clear the storage.
const version = 2;

export const loggedInUser = localStorageState(loggedInUserSchema.or(z.null()), `user-${version}`, null, diagnostics);
